import { useState, useEffect } from 'react'

export function useScrollProgress() {
  const [scrollProgress, setScrollProgress] = useState(0)

  useEffect(() => {
    let animationFrameId: number

    const handleScroll = () => {
      cancelAnimationFrame(animationFrameId)
      animationFrameId = requestAnimationFrame(() => {
        const totalScroll = document.documentElement.scrollTop
        const windowHeight =
          document.documentElement.scrollHeight -
          document.documentElement.clientHeight
        const scroll = `${totalScroll / windowHeight}`

        setScrollProgress(Number(scroll) || 0)
      })
    }

    window.addEventListener('scroll', handleScroll, { passive: true })
    handleScroll() // Init

    return () => {
      window.removeEventListener('scroll', handleScroll)
      cancelAnimationFrame(animationFrameId)
    }
  }, [])

  return scrollProgress
}
